import { useQuery } from 'react-query'
import api from 'balkerne-core/api'

export const useLocationGroups = () => {
  const path = '/locations/groups'
  const fetch = async () => await api.get(path).then(res => res.data)
  const { data, ...rest } = useQuery([path], fetch)
  return { ...rest, data: data ?? [] }
}

export const useLocation = (locationId, args) => {
  const path = `/locations/${locationId}`
  const fetch = async () => await api.get(path, { params: args }).then(res => res.data)
  const { data, ...rest } = useQuery([path, { ...args }], fetch, {
    enabled: locationId !== undefined && locationId !== null,
  })
  return { ...rest, data: data ?? null }
}

export const useLocationSubscription = (id, args) => {
  const path = `/locations/${id}/subscriptions`
  const fetch = async () => await api.get(path, { params: args }).then(res => res.data)
  const { data, ...rest } = useQuery([path, { ...args }], fetch, { enabled: id !== undefined })
  return { ...rest, data: data?.data ?? null }
}

export const useLocationSubscriptionsReadings = (id, args) => {
  const path = `/locations/${id}/subscriptions/readings`
  const fetch = async () => await api.get(path, { params: args }).then(res => res.data)
  const { data, ...rest } = useQuery([path, { ...args }], fetch, { enabled: id !== undefined })
  return { ...rest, data: data ?? null }
}

export const useLocations = (args, enabled = true) => {
  const path = '/locations'
  const fetch = async () => await api.get(path, { params: args }).then(res => res.data)
  const { data, ...rest } = useQuery([path, { ...args }], fetch, { enabled: enabled, refetchOnWindowFocus: false })
  return { ...rest, data: data ?? [] }
}

export const usePropertyAttributeCategories = args => {
  const path = `/locations/attributes/categories`
  const fetch = async () => await api.get(path, { params: args }).then(res => res.data)
  const { data, ...rest } = useQuery([path, { ...args }], fetch)
  return { ...rest, data: data?.data ?? [] }
}

export const usePropertyTypes = () => {
  const path = '/locations/types'
  const fetch = async () => (await api.get(path)).data
  const { data, ...rest } = useQuery(path, fetch)
  return { ...rest, data: data ?? [] }
}
